import { useEffect } from 'react';
import { Box, Button, Container, Divider, Stack, Typography } from '@mui/material';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import HomeIcon from '@mui/icons-material/Home';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { makeStyles } from 'tss-react/mui';
import { getLogger } from '@logging/logger';
import type { RegisteredRouter, RouteIds } from '@tanstack/react-router';

type OwnProps = {
  title?: string;
  message?: string;
  subMessage?: string;
  data?: unknown;
  isNotFound: boolean;
  routeId: RouteIds<RegisteredRouter['routeTree']>;
};

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: 2,
  },
  errorIconContainer: {
    borderRadius: '50%',
    width: 96,
    height: 96,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(219, 234, 254)',
  },
}));

export function NotFoundError({
  title,
  message,
  subMessage,
  routeId,
  /* isNotFound, OMITTED CAUSE ITS POINTLESS AND ALWAYS TRUE --------------------------------------------------------- */
  data,
}: OwnProps) {
  const { classes } = useStyles();
  useEffect(() => {
    getLogger().warn('NotFoundError page rendered', { route: routeId, data });
  }, [routeId, data]);
  return (
    <Container maxWidth='xl' className={classes.container}>
      <Stack spacing={4} alignItems='center' direction={'column'} marginBottom={16}>
        <div className={classes.errorIconContainer}>
          <SearchOffOutlinedIcon sx={{ fontSize: 44, color: '#2563eb' }} />
        </div>
        <Typography variant='h1'>{title || 'Page Not Found'}</Typography>
        <Typography variant='body1'>
          {message || "We couldn't find the page you're looking for. It may have been moved, deleted, or the URL might be incorrect."}
        </Typography>
        <Typography variant='body1'>{subMessage || 'Double-check the URL or head back to the homepage to find what you need.'}</Typography>
        <Box>
          <Stack direction={'row'} spacing={2}>
            <Button variant='contained' size='large' color='primary' onClick={() => window.location.assign('https://www.squadlocker.com')}>
              <HomeIcon />
              &nbsp; SquadLocker Homepage
            </Button>
          </Stack>
        </Box>
        <Divider flexItem />
        <Typography variant='subtitle1'>Still can't find what you're looking for?</Typography>
        <Button variant='contained' color='secondary' onClick={() => window.location.assign('https://www.squadlocker.com/email-us')}>
          <ContactSupportIcon />
          &nbsp; Contact Support
        </Button>
      </Stack>
    </Container>
  );
}
